<!-- tornar-recorrente-modal.component.html -->
<!--
  Shell fino do MatDialog (T-271): só o chrome (título + botão fechar + área
  rolável) que envolve `app-tornar-recorrente-form`, que hospeda o
  formulário de fato (extraído em T-271 — o markup do formulário morava
  aqui até então, ver o histórico do componente). Visual conforme a spec de
  UX-1 (howl-san, docs/design/compra-de-rotina-ux-spec.md §3).
-->
<div class="tornar-recorrente-modal">
  <h2 mat-dialog-title class="tornar-recorrente-modal__titulo">
    <span class="tornar-recorrente-modal__titulo-texto">
      <img src="assets/images/icons/recurring-purchase.svg" alt="" width="20" height="20"
        class="tornar-recorrente-modal__icone">
      {{ 'compra_rotina_modal_titulo' | transloco }}
    </span>
    <button mat-icon-button mat-dialog-close class="tornar-recorrente-modal__fechar"
      [attr.aria-label]="'fechar' | transloco" [disabled]="salvando">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="tornar-recorrente-modal__conteudo trm-body">
    <app-tornar-recorrente-form
      [itens]="data.itens"
      [modo]="modo"
      [origem]="data.origem"
      [compraExistente]="data.compraExistente"
      [nomeSugerido]="data.nomeSugerido"
      (salvo)="dialogRef.close($event)"
      (cancelado)="dialogRef.close()"
      (salvandoChange)="salvando = $event">
    </app-tornar-recorrente-form>
  </mat-dialog-content>
</div>
